"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSignedURL = getSignedURL;
exports.getThumbnail = getThumbnail;

var _immutable = require("immutable");

var _Thumbnail = _interopRequireDefault(require("customer-data-email/schema/attachments/Thumbnail"));

var THUMBNAILS = (0, _immutable.Map)({
  pdf: 'pdfFile',
  doc: '',
  txt: '',
  xls: '',
  default: 'file'
});

function getSignedURL(_ref, file) {
  var apiDomain = _ref.apiDomain,
      portalId = _ref.portalId;
  var fileId = file.get('id');
  var urlBase = "//" + apiDomain + "/filemanager/api/v2/files";
  return urlBase + "/" + fileId + "/signed-url-redirect?size=thumb&portalId=" + portalId;
}

function getThumbnail(urlConfig, file) {
  var url;

  if (file.get('type') === 'IMG') {
    if (file.get('hidden')) {
      if (file.hasIn(['meta', 'thumbs', 'thumb', 'friendly_url'])) {
        url = getSignedURL(urlConfig, file);
      }
    } else {
      url = file.getIn(['meta', 'thumbs', 'thumb', 'friendly_url']);

      if (!url) {
        url = file.get('friendly_url');
      }
    }
  }

  var icon = url ? undefined : THUMBNAILS.get(file.get('extension')) || THUMBNAILS.get('default');
  return (0, _Thumbnail.default)({
    icon: icon,
    url: url
  });
}